export const name = 'tpa' as const
export const TpaEventsListenerManagerSymbol = Symbol('TpaEventsListenerManager')
export const TpaPopupSymbol = Symbol('TpaPopup')
export const TpaModalSymbol = Symbol('TpaModal')
export const TpaFullScreenModeSymbol = Symbol('TpaFullScreenMode')
export const TpaSrcBuilderSymbol = Symbol('TpaSrcBuilder')
export const TpaSymbol = Symbol('Tpa')
